import type { ActivityViewMode } from './ActivityPage';
import type { ActivityGrouping } from './components/ActivityFeed';

/**
 * The widest viewport at which S, M and L draw the same card art in the
 * by-card grid: the grid is two columns there and the column, not the size's
 * max-height, limits the art (measured 2026-10-01: identical through 414px,
 * M and L grow from 420px). Below it M and L only add empty space under each
 * card, so the control is hidden and S is used.
 */
export const ACTIVITY_SIZE_INERT_MAX_WIDTH = 414;

/**
 * Whether the size is forced to S: the by-card grid at phone width. The page
 * hides the S / M / L control on exactly this condition.
 */
export const isActivitySizeForced = ({ isPhoneWidth, grouping }: { isPhoneWidth: boolean; grouping: ActivityGrouping }): boolean =>
  isPhoneWidth && grouping === 'by-card';

/**
 * The size the feed renders at. By trader sizes its tiles from the stored
 * value at every width, so only the by-card grid is forced. Read-only: the
 * stored preference is never changed by this.
 */
export const resolveActivityViewMode = (
  stored: ActivityViewMode,
  context: { isPhoneWidth: boolean; grouping: ActivityGrouping }
): ActivityViewMode => (isActivitySizeForced(context) ? 'images-S' : stored);
